import { HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';

export const ApiInterceptor: HttpInterceptorFn = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn
) => {
	const authSvc = inject(AuthService);

	let headers: HttpHeaders = req.headers;
	headers = headers.set('Content-Type', 'application/json');

	headers = authSvc.addTokenToEndpointRequestHeaders(headers, req.url);

	let clonedRequest = req.clone({ headers });

	return next(clonedRequest).pipe(
		catchError((error) => {
			authSvc.checkEndpointResponseError(error);
			return throwError(() => error);
		})
	);
}